import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import {
  Box,
  Typography,
  Button
} from '@material-ui/core';

import TopSection from '../common/topSection';
import {
  OutlinedTextField
} from '../common/fields';
import Alert from '../common/alert';


import { selectCreateStatus, createItemFamily, clearCreateStatus } from './itemFamilySlice';




const AddItemFamilyPage = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { itemOwnerId } = useParams();

  const [ state, setState ] = useState({name: '', code: ''});
  const [ validationErrors, setValidationErrors ] = useState({});
  const { status, error, itemFamily } = useSelector(selectCreateStatus);

  useEffect(() => {
    if(status === 'succeeded') {
      //Redirect to edit page
      history.replace(`/pih/owner/${itemOwnerId}/families/${itemFamily.code}`);
    }
  }, [status]);

  const handleChange = event => {
    setState({
      ...state,
      [event.target.name]: event.target.value
    });

    // Reset errors
    setValidationErrors({
      ...validationErrors,
      [event.target.name]: null
    });

    // Reset possible request states
    if(status === 'failed') {
      dispatch(clearCreateStatus());
    }
  };

  const validations = {
    code: value => {
      // In MDS id is in format "IF:1342:AA",
      // we change colon to dash in Stage. Accept both versions.
      // Note: space should also be accepted
      // IF:1234:AA, IF-123-345, IF-234 HKPL TRUCK

      if(!value) {
        return t('common:fieldIsRequired', {field: t('itemFamily:code')});
      } else if(!/^IF[A-Z\d\-\:\+. ]+$/.test(value)) { // eslint-disable-line no-useless-escape
        return t('itemFamily:invalidCodeFormat');
      }

      return null;
    },
    name: value => {
      if(!value || value.trim() === '') {
        return t('common:fieldIsRequired', {field: t('itemFamily:name')});
      }

      return null;
    }
  };

  const validate = () => {
    const newErrors = {};
    Object.keys(state).forEach(field => {
      const value = state[field];
      newErrors[field] = validations[field](value);
    });

    setValidationErrors(newErrors);

    if(Object.keys(newErrors).every(field => newErrors[field] === null)) {
      return true;
    }

    return false;
  }

  const handleSubmit = event => {
    event.preventDefault();

    if(status !== 'loading') {
      if(validate()) {
        dispatch(createItemFamily({itemOwnerId, itemFamilyData: state}));
      }
    }
  }

  return (
    <>
      <TopSection>
        <Typography variant="h4" component="h1">{t('itemFamily:addNew')}</Typography>
      </TopSection>

      <Box p={3}>

        {status === 'failed' ? <Alert severity="error">{t(`errors:${error.message}`)}</Alert> : null}

        <form onSubmit={handleSubmit}>

          <Box my={3}>
            <OutlinedTextField
              label={t('itemFamily:code')}
              name="code"
              value={state.code}
              onChange={handleChange}
              error={!!validationErrors.code || (status === 'failed' && !!error?.fields?.code)}
              helperText={(status === 'failed' && error?.fields?.code) || validationErrors.code || t('itemFamily:codeHelperText')}
            />
          </Box>
          <Box my={3}>
            <OutlinedTextField
              label={t('itemFamily:name')}
              name="name"
              value={state.name}
              onChange={handleChange}
              error={!!validationErrors.name || error?.fields?.name}
              helperText={(status === 'failed' && error?.fields?.name) || validationErrors.name || t('itemFamily:nameHelp' + itemOwnerId) || t('itemFamily:nameHelp')}
            />
          </Box>

          <Button color="primary" variant="contained" disabled={status === 'loading'} type="submit">{t('common:create')}</Button>
        </form>
      </Box>
    </>

  );
};

export default AddItemFamilyPage;
